import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { SpinnerVisibilityService } from 'ng-http-loader';
import Swal from 'sweetalert2'
import { BMApiService } from '../../../services/bm.service';
import { Router } from '@angular/router';
import { UserService } from '../../../services/user.service';
import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,
  GridStateChange,

  MenuCallbackArgs,
  OnEventArgs
} from 'angular-slickgrid';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { UtilityService } from '../../../services/utility.service';
import { AdminApiService } from '../../../services/admin.service';
import { tranbenchmarkkpi, tranbenchmarkkpihistory, benchmarkkpirelease, year } from '../../../models/slakpi';
import { division } from '../../../models/admin';
import { ToasterService } from '../../../toaster.service';
import { SLAKPIApiService } from '../../../services/slakpi.service';
@Component({
  selector: 'app-bench-mark-release',
  templateUrl: './bench-mark-release.component.html',
  styleUrls: ['./bench-mark-release.component.css']
})
export class BenchMarkReleaseComponent implements OnInit {
  
  public benchMarkYear_data: any;
  public currentHalf_data: any;
  public division_data: any;
  public gridApi: any;
  public gridColumnApi: any;
  public columnDefs: any;
  public defaultColDef: any;
  public rowData: any;
  public PopoverModule;
  modalRef: BsModalRef;
  @ViewChild('viewtemplate', { static: false }) viewtemplate: TemplateRef<any>;
  columnDefinitions: Column[];
  gridOptions: GridOption;
  dataset: any;
  yearfilter: any;
  divisionUnofilter: any;
  halffilter: any;
  angularGrid: AngularGridInstance;
  public BenchmarkKPIRelease_data: any;
  public loading: boolean = true;
  public pageAction: string = 'add';
  tranBenchMarkKPIHistory_data: any;
  isStart:boolean=true;
  selectedRows: any = [];
  currentHalf?: number;
  user: any = {};
  login_UserID: string; // number
  isAdmin: boolean = false;
  public isBMChampion: boolean = false;
  public isBMTeam: boolean = false;
  public isBMVisitor: boolean = false;
  public isBMAdmin: boolean = false;
  searchText: string;
  dataSearch: any;
  noDataImg: any;
  tenantUno: any;
    yearData: any;
  constructor(public restApi: BMApiService, public restAdminApi: AdminApiService, private toaster: ToasterService, public utilityService: UtilityService, private router: Router, private spinner: SpinnerVisibilityService, private userService: UserService, private modalService: BsModalService, public restSLAKPIApi: SLAKPIApiService) {
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.noDataImg = this.utilityService.getnodataImage();
    this.tenantUno = this.user.tenantUno;
    this.ValidateUserAccess();
  }
  //Method used To Validate User Permission
  ValidateUserAccess() {
    

    this.isAdmin = (this.user.role == 'Administrator' || this.user.role == 'BM Administrator') ? true : false;

    if (this.user.role == 'BM Champions')
      this.isBMChampion = true;
    if (this.user.role == 'BM Team')
      this.isBMTeam = true;
    if (this.user.role == 'BM Visitor')
      this.isBMVisitor = true;
    if (this.user.role == 'BM Administrator') { this.isBMAdmin = true; }

    if (!this.isAdmin) {
      let userPermissionData = this.userService.getUserRights("KPI Data Acquisition");
      if (userPermissionData != null && userPermissionData != undefined && userPermissionData.length > 0) {
        if (userPermissionData[0].showPage == 1) {

        }
        else {
          this.router.navigateByUrl('/access-denied');
        }
      }
    }

  }
  ngOnInit() {
    this.userService.CheckLogin();
    this.currentHalf = Number(this.user.currentHalf);
    this.gridOptions = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 20
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,
      enableCheckboxSelector: true,
      checkboxSelector: {
        // optionally change the column index position of the icon (defaults to 0)
        // columnIndexPosition: 1,

        // remove the unnecessary "Select All" checkbox in header when in single selection mode
        hideSelectAllCheckbox: false,

        // you can override the logic for showing (or not) the expand icon
        // for example, display the expand icon only on every 2nd row
        // selectableOverride: (row: number, dataContext: any, grid: any) => (dataContext.id % 2 === 1)
        selectableOverride: (row: number, data: any, grid: any) => ( data.rowType == 'Ready')
      },
      multiSelect: false,
      rowSelectionOptions: {
        // True (Single Selection), False (Multiple Selections)
        selectActiveRow: true,
      },



    };
    //this.getBenchMarkYear();
    this.loadYear();
    this.getDivisions();
    this.getcurrentHalf();
    this.LoadBenchmarkKPIRelease();
  }

  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    this.userService.angularGrid = angularGrid;
  }
  handleSelectedRowsChanged1(e, args) {
    
    let data = args.dataContext;
   
    if (Array.isArray(args.rows) && this.angularGrid) {
      this.selectedRows = this.angularGrid.gridService.getSelectedRowsDataItem();
    }
  }
  getBenchMarkYear() {
    
    let date = new Date();
    let pastYear = date.getFullYear() - 1;
    let currentYear = date.getFullYear();
    let futureYear = date.getFullYear() + 1;

    this.benchMarkYear_data = [
      { text: pastYear, value: pastYear },
      { text: currentYear, value: currentYear },
      { text: futureYear, value: futureYear }
    ];
  }

  getcurrentHalf() {
    
    
    this.currentHalf_data = [
      { text: 'First Half', value: 1 },
      { text: 'Second Half', value: 2 }
    ];
  }

  getDivisions() {

    let inpValue = new division();
    inpValue.userUno = this.login_UserID;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 5;
    inpValue.tenantUno = this.tenantUno;
    this.restApi.getDivisions(inpValue)
      .subscribe(data => {
        this.division_data = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }
  searchKPIRelease() {
    
    let temp = this;
    this.selectedRows = [];
   // this.spinner.show();
    this.loading = true;
    if (!this.isStart) {
      setTimeout(function () { temp.LoadBenchmarkKPIRelease(); }, 1000)

    }

  }


  LoadBenchmarkKPIRelease() {
    
    this.selectedRows=[];
    let currentYear = new Date().getFullYear();


    this.yearfilter = this.yearfilter ? this.yearfilter : currentYear;
    this.halffilter = this.currentHalf;//this.halffilter ? this.halffilter : 1;
    let inpValue = new benchmarkkpirelease();
    inpValue.benchmarkyear = this.yearfilter ? this.yearfilter : currentYear;
   inpValue.kpiType = this.halffilter ? this.halffilter : 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    inpValue.businessDivisionUno = this.divisionUnofilter ? this.divisionUnofilter : 0;
    this.restApi.getBenchMarkKPIRelease(inpValue)
      .subscribe((data: any) => {
        
        let rtn_data = data;
        if (rtn_data != null && rtn_data.length > 0) {

          //uniqBy(data, 'kpiUno');
          const mockDataset = [];
          for (let i = 0; i < rtn_data.length; i++) {



            mockDataset[i] = {
              id: rtn_data[i].kpiUno,
              kpiCode: rtn_data[i].kpiCode,
              kpiNameEn: rtn_data[i].kpiNameEn,
              dataOwnerName: rtn_data[i].dataOwnerName,
              dataOwnerUno: rtn_data[i].dataOwnerUno,
              level1ApproverUno: rtn_data[i].level1ApproverUno,
              level2ApproverUno: rtn_data[i].level2ApproverUno,
              level3ApproverUno: rtn_data[i].level3ApproverUno,
              targetValue: rtn_data[i].targetValue,
              targetValueString: rtn_data[i].targetValue.tostring,
              kpiRule: rtn_data[i].kpiRule,
              formula: rtn_data[i].formula,
              kpiYear: rtn_data[i].kpiYear,
              kpiQuarter: rtn_data[i].kpiQuarter,
              rowType: rtn_data[i].rowType
            };
          }
          //this.dataset = mockDataset;
         
          if (mockDataset.length > 0) {
            this.dataset = mockDataset.filter(
              (thing, i, arr) => arr.findIndex(t => t.id === thing.id) === i
            );
            this.dataSearch = this.dataset;
            this.setColnDefn();
          }
          this.BenchmarkKPIRelease_data = rtn_data;
          this.isStart = false;
          this.loading = false;
          this.spinner.hide()
        }
        else {
         this.dataset = [];
          this.isStart = false;
          this.loading = false;
          this.spinner.hide()
        }
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }


  searchGrid() {
    if (this.searchText != "") {
      this.dataset = this.dataSearch.filter(a =>
        a.kpiCode && a.kpiCode.toLowerCase().includes(this.searchText.toLowerCase())
        || (a.kpiNameEn && a.kpiNameEn.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.dataOwnerName && a.dataOwnerName.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.targetValueString && a.targetValueString.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.rowType && a.rowType.toLowerCase().includes(this.searchText.toLowerCase()))
       
      );
    }
    else
      this.dataset= this.dataSearch;
  }
  setColnDefn() {
    let temp = this;
    this.columnDefinitions = [
      {
        id: 'kpiCode', name: 'KPI Code', field: 'kpiCode', sortable: true, width: 50,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'kpiCode', 'kpiCode'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'kpiNameEn', name: 'KPI', field: 'kpiNameEn', sortable: true, width: 150,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'kpiNameEn', 'kpiNameEn'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'dataOwnerName', name: 'Owner', field: 'dataOwnerName', sortable: true, width: 100,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'dataOwnerName', 'dataOwnerName'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'targetValue', name: 'Target', field: 'targetValue', sortable: true, width: 50,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'targetValue', 'targetValue'),
          model: Filters.multipleSelect,
        }
      },
      //{
      //  id: 'kpiRule', name: 'KPI Rule', field: 'kpiRule', sortable: true,
      //  type: FieldType.string, filterable: true,
      //  filter: {
      //    collection: this.uniqueArray(this.dataset, 'kpiRule', 'kpiRule'),
      //    model: Filters.multipleSelect,
      //  }
      //},
      {
        id: 'rowType', name: 'Row Type', field: 'rowType', sortable: true, width: 50,
        type: FieldType.string, filterable: true,
        formatter: (row, cell, val, columnDef, data) => {
          if (data.rowType == 'Ready')
            return '<span  class="status-area status-green">Ready</span>';
          
          else if (data.rowType == 'E')
            return '<span  class="status-area status-yellow">E</span>';
          else if (data.rowType == 'T')
            return '<span  class="status-area status-yellow">T</span>';
        },
        filter: {
          collection: this.uniqueArray(this.dataset, 'rowType', 'rowType'),
          model: Filters.multipleSelect,
        }
      },

      {
        id: 'action', name: 'Action', field: 'action', width: 50, cssClass: 'blue',
        type: FieldType.string, formatter: (row, cell, val, columnDef, data) => {

          if (!this.isBMVisitor && data.rowType == 'Ready')     
            return '<span style="cursor:pointer"><i class="fa fa-send fa-lg"></i> Release KPI</span>';
          else if(data.rowType == 'T')
            return '<span style="cursor:pointer"><i class="fa fa-pencil-square-o fa-lg"></i> KPI Target</span>';
          else if(data.rowType == 'E')
            return '<span style="cursor:pointer"><i class="fa fa-pencil-square-o fa-lg"></i> BM Entry</span>';
        },
        onCellClick: (e: Event, args: OnEventArgs) => {
          
          let data = args.dataContext;
          if (!this.isBMVisitor && data.rowType == 'Ready') {
            this.selectedRows = [];
            let mockDataset = [];
            mockDataset.push({
              id: data.id,
              kpiCode: data.kpiCode,
              kpiNameEn: data.kpiNameEn,
              dataOwnerName: data.dataOwnerName,
              dataOwnerUno: data.dataOwnerUno,
              level1ApproverUno: data.level1ApproverUno,
              level2ApproverUno: data.level2ApproverUno,
              level3ApproverUno: data.level3ApproverUno,
              targetValue: data.targetValue,
              kpiRule: data.kpiRule,
              rowType: data.rowType
            });

            this.selectedRows = mockDataset;
            this.onBenchmarkKPIRelease('action');
          }
          else if (data.rowType == 'T') {
            this.router.navigateByUrl('/benchmark-kpi-target');
            return false;
          }
          else if (data.rowType == 'E') {
            this.router.navigateByUrl('/benchmarkkpi');
            return false;
          }


               

        }
      }
      //{
      //  id: 'action', name: 'Action', field: 'action', cssClass: 'blue', width: 50,
      //  excludeFromExport: true,
      //  formatter: this.actionFormatter,
      //  cellMenu: {
      //    hideCloseButton: false,
      //    commandTitleKey: 'COMMANDS',
      //    commandItems: [
      //      //{
      //      //  command: 'delete-row', titleKey: 'EDIT_ROW', positionOrder: 62, title: 'View History',
      //      //  iconCssClass: 'fa fa-pencil-square-o', cssClass: 'blue', textCssClass: 'bold',
      //      //  action: (e, args) => {
      //      //    this.pageAction = 'view';
      //      //    let rdata: any = args.dataContext;
      //      //    this.getViewHistory(rdata.id);

      //      //    this.modalRef = this.modalService.show(
      //      //      this.viewtemplate,
      //      //      Object.assign({}, { class: 'gray modal-lg' })
      //      //    );
                
      //      //  },
      //      //  // only show command to 'Delete Row' when the task is not completed

      //      //},
      //      //{ divider: true, command: '', positionOrder: 63 },
      //      {
      //        command: 'release-row', titleKey: 'Release_ROW', positionOrder: 66, title: 'Release KPI',
      //        itemVisibilityOverride: (args: MenuCallbackArgs) => {
      //          let data = args.dataContext;
               
      //          if (!this.isBMVisitor && data.rowType == 'Ready')
      //            return true;
      //          else return false;
      //        },
      //        iconCssClass: 'fa fa-send', cssClass: 'green', textCssClass: 'bold',
      //        action: (e, args) => {
      //          this.selectedRows = [];
      //          let data = args.dataContext;

      //          let mockDataset = [];
      //         mockDataset.push({
      //           id: data.id,
      //           kpiCode: data.kpiCode,
      //           kpiNameEn: data.kpiNameEn,
      //           dataOwnerName: data.dataOwnerName,
      //           dataOwnerUno: data.dataOwnerUno,
      //           level1ApproverUno: data.level1ApproverUno,
      //           level2ApproverUno: data.level2ApproverUno,
      //           level3ApproverUno: data.level3ApproverUno,
      //           targetValue: data.targetValue,
      //           kpiRule: data.kpiRule,
      //            rowType: data.rowType
      //          });

      //          this.selectedRows = mockDataset;
      //          this.onBenchmarkKPIRelease('action');
      //        },
      //        // only show command to 'Delete Row' when the task is not completed

      //      },


      //    ],
      //  }
      //}




    ]


  }


  getViewHistory(id: number) {
    

      let inpValue = new tranbenchmarkkpihistory();

    inpValue.itemUno = id;
    inpValue.condition = 1;
    inpValue.userUno = this.login_UserID;
      this.restApi.getTranBenchMarkKPIHistory(inpValue)
        .subscribe(data => {
          
          this.tranBenchMarkKPIHistory_data = data;
        },
          (error) => {
            //Called when error
          }
        ).add(() => {
          //Called when operation is complete (both success and error)
        });
    
  }

  actionFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    return `<div class="fake-hyperlink"> <i class="fa fa-ellipsis-h fa-lg"></i></div>`;
  };
  uniqueArray(arrayList, val, label) {
    var temp = this;
    var aList = [];
    if (arrayList) {
      for (var i = 0, l = arrayList.length; i < l; i++)
        if (aList.filter(item => item.label == temp.Checklabel(arrayList[i][label])).length == 0) {

          aList.push({
            'value': this.CheckValue(arrayList[i][val]), 'label': this.Checklabel(arrayList[i][label])
          });
        }
    }


    aList.sort((a: any, b: any) => {
      if (a['value'] < b['value']) {
        return -1;
      } else if (a['value'] > b['value']) {
        return 1;
      } else {
        return 0;
      }
    });
    return aList;
  }

  Checklabel(val) {
    if (val != undefined && val != null && val != '' && val != ' ')
      return val;
    else
      return ''

  }

  CheckValue(val) {
    if (val != undefined && val != null && val != '' && val != ':')
      return val;
    else
      return ' '

  }

  IsNull(val) {
    if (val != undefined && val != null && val != '') {
      val = val.trim()
      return val.charAt(0).toUpperCase() + val.slice(1);
    }
    else
      return ' '

  }


  onBenchmarkKPIRelease(type:any) {
    
    Swal.fire({
      title: 'Benchmark KPI Release',
      text: 'Please confirm to Release KPI',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.value) {
        this.pageAction = 'release';
        
        this.addEditBenchmarkKPIRelease();
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        if (type == 'action') { this.selectedRows = []; }
      }
    });
    return false;
  }

  addEditBenchmarkKPIRelease() {
    
    let objKPIRelease = new benchmarkkpirelease();

    
    //Transaction Entry
    
        let entryItems=this.selectedRows;      
    let strXmlValue = '<roots>';
    let listKPIRelease = [];
        for (var i = 0; i < entryItems.length; i++) {
         
          strXmlValue += "<root>";
          strXmlValue += "<KPIUno>" + entryItems[i].id + "</KPIUno>";
          strXmlValue += "<BenchmarkYear>"+this.yearfilter+"</BenchmarkYear>";
          strXmlValue += "<DataOwnerUno>" + entryItems[i].dataOwnerUno + "</DataOwnerUno>";
          strXmlValue += "<Level1ApproverUno>" + entryItems[i].level1ApproverUno + "</Level1ApproverUno>";
          strXmlValue += "<Level2ApproverUno>" + entryItems[i].level2ApproverUno + "</Level2ApproverUno>";
          strXmlValue += "<Level3ApproverUno>" + entryItems[i].level3ApproverUno + "</Level3ApproverUno>";
          strXmlValue += "<TargetValue>" + entryItems[i].targetValue + "</TargetValue>";
          strXmlValue += "<IsRelease>true</IsRelease>"
          strXmlValue += "<IsActive>1</IsActive>"
          strXmlValue += "</root>";

          let objBMKPI = new benchmarkkpirelease();
          objBMKPI.kpiUno = entryItems[i].id;
          objBMKPI.dataOwnerUno = entryItems[i].dataOwnerUno;
          objBMKPI.kpiNameEn = entryItems[i].kpiNameEn;
          objBMKPI.kpiCode = entryItems[i].kpiCode;
          objBMKPI.formula = entryItems[i].formula;
          //objBMKPI.benchmarkyear = entryItems[i].benchmarkyear;
          //objBMKPI.kpiType = entryItems[i].kpiType;
          listKPIRelease.push(objBMKPI);
        }
    strXmlValue += '</roots>';

      objKPIRelease.xmlValue = strXmlValue;
      objKPIRelease.count = entryItems.length;
    
    objKPIRelease.userUno = this.login_UserID;
    objKPIRelease.tenantUno = this.tenantUno;
    objKPIRelease.benchmarkyear = this.yearfilter;
    objKPIRelease.kpiType = (this.halffilter ==1)? 2:4;
    objKPIRelease.xmlNotificationValue = '';
    objKPIRelease.objkpiRelease = listKPIRelease;
    this.restApi.addEditBenchMarkKPIRelease(objKPIRelease)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '') {
         // Swal.fire('Error', 'Something went wrong', 'error');
          this.toaster.show('error', 'Error', 'Something went wrong');
          this.spinner.hide();
        }
        else {
          
          //Swal.fire({
          //  type: 'success',
          //  title: 'Bench Mark KPI Released.',
          //  showConfirmButton: false,
          //  timer: 1500
          //})
          this.selectedRows = [];
          this.toaster.show('success', 'Success', 'Benchmark KPI released.');
          setTimeout(() => { this.spinner.hide(); this.loading = true; this.LoadBenchmarkKPIRelease(); }, 900);

        }



      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.spinner.hide();
      });
  }

  loadYear() {

    let inpValue = new year();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 0;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    
    this.restSLAKPIApi.getYearMaster(inpValue)
      .subscribe(data => {
        
        this.yearData = data;

      },
        (error) => {
          //Called when error

        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });
  }
}


